export default __webpack_public_path__ + "static/media/testimonial-quote.svg.df52c734.svg";